import { render, staticRenderFns } from "./QuickTipsReviewSplitIdConfirmation.vue?vue&type=template&id=9c0f5186&scoped=true&"
import script from "./QuickTipsReviewSplitIdConfirmation.vue?vue&type=script&lang=js&"
export * from "./QuickTipsReviewSplitIdConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c0f5186",
  null
  
)

export default component.exports